export const templateComponentEnabledKeys = [
  "mock-component",
  "breadcrumbs",
  "call-to-action",
  "dated-searches",
  "check-prices",
  "deals",
  "page-heading",
  "page-heading_wizard",
  "separator",
  "airport-address",
  "price-trend-graph",
  "link-juice",
  "property-filters",
  "property-filters_pills",
  "property-filters_sort",
  "hotel-recent-reviews",
  "hotel-recent-reviews_view",
  "hotels",
  "hotels_view",
  "hotels_carousel",
  "hotels_travellers-loved",
  "hotels_summarized-hotels",
  "hotels_summarized-hotels-carousel",
  "frequently-asked-questions",
  "destination-hero",
  "destination-neighborhoods",
  "te-neighborhood_neighborhood_with_dx_hsr",
  "twitter-embed",
  "links",
  "top-cities",
  "editorial",
  "wizard-hotel-pwa-v2",
  "tab-group",
  "recently-viewed-hotels",
  "region",
  "region_meso-collapsible-group",
  "region_mobile-confidence-messages-carousel",
  "region_multi-column",
  "NativeAdContainerRegion",
  "region_nts-flex-item",
  "region_native-tile-showcase",
  "region_theme-selector",
  "region_toggle",
  "region_responsive-toggle",
  "region_two-buttons",
  "region_property-filters-interactive",
  "star-rating-links",
  "wizard-hotel-pwa",
  "maps",
  "maps_button",
  "region_spacing-container",
];
